<template>
	<div class="places grid">
		<div class="filter row">
			<div class="location no-before" :class="{'narrow': display_opting}">
				<button class="mobile-filter-toggle" :class="{'bordered': activeFilters}" @click="toggleMobileFilter"><i class="fal fa-filter"></i></button>
			</div>

			<div class="filters">
				<span v-html="labels.filter"></span>

				<div class="toggles">
                    <trigger-popup :toggle-label="labels.keyword" :active-filters="query.keyword.length > 0">
                    	<input type="text" name="keyword" :placeholder="labels.keywordPlaceholder" v-model="temp.keyword">
                    </trigger-popup>

                    <trigger-popup :toggle-label="labels.amenities" :active-filters="query.amenities.length > 0">
                    	<ul class="checkbox-wrapper">
                            <li v-for="term in amenities">
                                <input class="custom-checkbox" name="amenities[]" v-model="temp.amenities" :id="'amenities-'+term.term_id" type="checkbox" :value="term.term_id">
                                <label :for="'amenities-'+term.term_id">{{term.name}}</label>

                            </li>
                        </ul>
                    </trigger-popup>

                    <trigger-popup :toggle-label="labels.type" :active-filters="query.types.length > 0">
                    	<ul class="checkbox-wrapper">
                            <li v-for="term in types">
                                <input class="custom-checkbox" name="types[]" v-model="temp.types" :id="'types-'+term.term_id" type="checkbox" :value="term.term_id">
                                <label :for="'types-'+term.term_id">{{term.name}}</label>

                            </li>
                        </ul>
                    </trigger-popup>
				</div>
			</div>

			<div v-if="display_opting" class="button participation-toggle" :class="{'bordered': query.participating}" @click="handleParticipationToggle" :title="labels.participating">
            	<span class="label" v-html="labels.participating_short"></span>
            	<i class="fa-check-circle" :class="{'fas': query.participating, 'far': !query.participating}"></i>
            </div>
		</div>

		<mobile-filter v-if="mobileFilterActive" v-on:closeFilter="closeFilter" v-on:applyFilters="applyFilters">
			<label v-html="labels.keyword"></label>
			<div class="options">
				<input type="text" name="keyword" :placeholder="labels.keywordPlaceholder" v-model="temp.keyword">
			</div>

			<label v-html="labels.amenities"></label>
			<div class="options">
				<ul class="checkbox-wrapper">
                    <li v-for="term in amenities">
                        <input class="custom-checkbox" name="amenities[]" v-model="temp.amenities" :id="'amenities-'+term.term_id" type="checkbox" :value="term.term_id">
                        <label :for="'amenities-'+term.term_id">{{term.name}}</label>

                    </li>
                </ul>
            </div>

            <label v-html="labels.type"></label>
			<div class="options">
				<ul class="checkbox-wrapper">
	                <li v-for="term in types">
	                    <input class="custom-checkbox" name="types[]" v-model="temp.types" :id="'types-'+term.term_id" type="checkbox" :value="term.term_id">
	                    <label :for="'types-'+term.term_id">{{term.name}}</label>

	                </li>
	            </ul>
            </div>
		</mobile-filter>

		<div class="content row">
			<div id="map" class="full-width"></div>

			<div class="map-legend" v-if="affiliations && affiliations.length">
				<label v-html="labels.legend"></label>
				<ul>
					<li v-for="affiliation in affiliations" v-if="affiliation.term_id != default_affiliation">
						<div class="svg" v-html="affiliation.pinSvg"></div>

						<span v-html="affiliation.name"></span>
					</li>
				</ul>
			</div>

			<div class="inline-modal-overlay"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				namespace: '/wp-json/baytek/v1/place/search',
				results: {
                    loading: false,
                    posts: []
                },
                query: {
                    keyword: '',
                    amenities: theme.prefiltered.amenities,
                    types: theme.prefiltered.placeTypes,
                    participating: hpd_helper.display_opting ? true : false,
                },
                loaded: false,
                amenities: [],
                types: [],
                temp: {
                	keyword: '',
                	amenities: [],
                	types: []
                },
                display_opting: hpd_helper.display_opting ? true : false,
                hasLocationInput: false,
                all_places: [],
                clusterer: null
			}
		},

		computed: {
			activeFilters() {
				return this.query.keyword.length > 0 || this.query.amenities.length > 0 || this.query.types.length > 0;
			}
		},

		watch: {
			'query.keyword'() {
				this.filterPlaces();
			},

			'query.amenities'() {
				this.filterPlaces();
			},

			'query.types'() {
				this.filterPlaces();
			},

			'query.participating'() {
				this.filterPlaces();
			},

			'results.posts'(val) {
				this.updateMap();
			}
		},

		created() {
			//Set values from localized data
			this.labels = theme.labels;
			this.amenities = theme.amenities;
			this.types = theme.placeTypes;

			//Set map center point
			this.maps.location = {
				lat: 45.8630644,
				lng: -74.4207475
			};

			//Get all places
			this.getData(hpd_helper.all_places_json_url)
				.then(json => {
					
					this.all_places = Object.values(json);
					this.maybePopulateMap();
				});
		},

		mounted() {
			this.initMap();
			this.handleFilterTriggers();
			this.maybePopulateMap();
		},

		methods: {
			maybePopulateMap() {
				if (this.maps.map != null && this.all_places != []) {
					this.getResults();
				}
			},

			getResults() {
				this.filterPlaces();
			},

			filterPlaces() {
				if (this.updatingFilters) return;

                this.getPlaces();
            },

			getPlaces() {
				//Make sure we have some places
				if (!this.all_places.length) return;

				//Don't double filter
				if (this.results.loading) return;
				this.results.loading = true;

				//Loop through all places JSON and make a filtered list of places
				let filtered = [];

				this.all_places.forEach((place) => {
					//Check for keyword
					if (this.query.keyword.length) {
						let keyword = this.query.keyword.toLowerCase();

						//Check the title and description
						if (place.title.toLowerCase().indexOf(keyword) == -1 && place.excerpt.toLowerCase().indexOf(keyword) == -1) {
							//Not a match
							return;
						}
					}

					//Check for amenities
					if (this.query.amenities.length) {
						let matches = this.query.amenities.filter(term_id => place.amenities.includes(term_id));

						if (matches.length < 1) {
							return;
						}
					}

					//Check for types
					if (this.query.types.length) {
						let matches = this.query.types.filter(term_id => place.types.includes(term_id));

						if (matches.length < 1) {
							return;
						}
					}

					//Check for participating
					if (hpd_helper.display_opting && this.query.participating) {
						if (!place.participating) {
							return;
						}
					}

					//Append to the array if it matches all the filters (haven't broken the loop)
					filtered.push(place);
				});

				//Now that we have our newly filtered list of places, update the map
				this.results.posts = filtered;
				this.results.loading = false;
				this.loaded = true;
			},

			updateMap() {
				let self = this;
				this.clearMarkers();

				let parser = new DOMParser();

				if (this.results.posts.length) {
					this.maps.bounds = new google.maps.LatLngBounds();

					this.results.posts.forEach((place) => {
						let affiliationId = place.affiliations && place.affiliations.length ? place.affiliations[0] : parseInt(this.default_affiliation);
						let affiliation = this.affiliations.find((term) => term.term_id == affiliationId);

						let pinSvg = parser.parseFromString(affiliation.pinSvg, 'image/svg+xml').documentElement;
						let hoverPinSvg = parser.parseFromString(affiliation.hoverPinSvg, 'image/svg+xml').documentElement;

						let marker = new google.maps.marker.AdvancedMarkerElement({
							map: this.maps.map,
							position: {lat: place.meta.lat, lng: place.meta.lng},
							content: pinSvg
						});

						//Link marker and place
						marker.refersTo = place;
						place.marker = marker;

						//Store pin info
						marker.pins = {
							initial: pinSvg,
							hover: hoverPinSvg
						}

						this.maps.bounds.extend(marker.position);
						this.maps.markers.push(marker);

						//Show infowindow on click
						google.maps.event.addListener(marker, 'click', function() {
							self.showInfowindow(this);
						});
					});

					//Fit map to new bounds
					this.maps.map.fitBounds(this.maps.bounds);

					//Cluster the markers
					this.clusterer.addMarkers(this.maps.markers);
				}
			},

			clearMarkers() {
				if (this.maps.markers.length > 0) {
					this.maps.markers.forEach(marker => marker.setMap(null));
				}

				this.maps.markers = [];
				this.clusterer.clearMarkers();
			},

			handleParticipationToggle(e) {
				e.preventDefault();

				this.query.participating = !this.query.participating;
			},

			getDirectionsUrl(post) {
				let url = 'https://www.google.com/maps/dir/?api=1';

				if (post.meta.lat && post.meta.lng) {
					url += `&destination=${post.meta.lat},${post.meta.lng}`;
				}
				else {
					url += `&destination=${encodeURI(post.title)}`;
				}

				return url;
			},

			setInfowindowContent(post) {
				//Open the content div
				let content = '<div class="infowindow-content">';

				//Put in the picture
				content += `<img src=${post.featured_image_url} class="featured-image">`;

				//Text area
				content += '<div class="content-area">';

				//Participating?
				if (this.display_opting && post.participating) {
					content += '<span class="participation tag"></span>';
				}

				//Place title
				content += `<a href="${post.permalink}" target="_blank"><h5 class="item-title">${post.title}</h5></a>`;

				//Formatting paragraph
				content += '<p>';

				//Location
				content += `<span class="location h6">${post.meta.location}</span><br/>`;

				//Open links
				content += '<span class="edit-links smaller">';

				//View place link
				content += `<a href="${post.permalink}" target="_blank">${this.labels.viewPlace}</a>&nbsp;|&nbsp;`;

				//Get directions link
				content += `<a href="${this.getDirectionsUrl(post)}" target="_blank">${this.labels.getDirections}</a>`;

				//Close links
				content += '</span>';

				//Close the formatting paragraph
				content += '</p>';

				//Close the text area
				content += '</div>';

				//Close the content div
				content += '</div>';

				this.maps.infowindow.setContent(content);
			},
		},
	}
</script>
